import React, { useState, useEffect } from 'react';
import { Modal, Select, Alert } from 'antd';
import ReactDOM from 'react-dom/client';
import {getConnectionStatus} from "../../services/socketService";

const { Option } = Select;

export function showSectionSelectorModal({ sections, entityId, goalService, promoterService }) {
    return new Promise((resolve) => {
        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = ReactDOM.createRoot(container);

        const SectionModal = () => {
            const [selectedSection, setSelectedSection] = useState(null);
            const [status, setStatus] = useState(null);
            const [loading, setLoading] = useState(false);
            const [connectionStatus, setConnectionStatus] = useState(getConnectionStatus());

            useEffect(() => {
                const interval = setInterval(() => {
                    setConnectionStatus(getConnectionStatus());
                }, 1000);
                return () => clearInterval(interval);
            }, []);

            useEffect(() => {
                if (!selectedSection) {
                    setStatus(null);
                    return;
                }

                const check = async () => {
                    setLoading(true);
                    const filters = {
                        entityId: { value: entityId, operator: 'eq' },
                        sectionId: { value: [selectedSection], operator: 'in' },
                    };

                    try {
                        if (connectionStatus){
                            // const { data: goals } = await goalService.getAll(filters);
                            // const { meta: metaPromoters } = await promoterService.getAll(filters);
                            // if (goals.length === 0) {
                            //     setStatus({ valid: false, message: 'Esta sección no tiene límite asignado.' });
                            // } else if (goals[0].promotersLimit <= metaPromoters.totalItems) {
                            //     setStatus({ valid: false, message: 'Se alcanzó el límite de promotores.' });
                            // } else {
                            //     setStatus({ valid: true, remaining: goals[0].promotersLimit - metaPromoters.totalItems });
                            // }
                            setStatus({ valid: true, remaining: null });
                        }else{
                            setStatus({ valid: true, remaining: 1 });
                        }
                    } catch (e) {
                        setStatus({ valid: false, message: 'Error al validar la sección.' });
                    } finally {
                        setLoading(false);
                    }
                };

                check();
            }, [connectionStatus, selectedSection]);

            const handleCancel = () => {
                destroy();
                resolve(false);
            };

            const handleOk = () => {
                if (status?.valid && selectedSection) {
                    destroy();
                    resolve(selectedSection); // o true si prefieres solo un booleano
                }
            };

            const destroy = () => {
                setTimeout(() => {
                    root.unmount();
                    document.body.removeChild(container);
                });
            };

            return (
                <Modal
                    open
                    title="Seleccionar sección"
                    onCancel={handleCancel}
                    onOk={handleOk}
                    okText="Aceptar"
                    cancelText="Cancelar"
                    okButtonProps={{ disabled: !status?.valid, loading }}
                >
                    <Select
                        style={{ width: '100%' }}
                        placeholder="Selecciona una sección"
                        value={selectedSection || undefined}
                        onChange={setSelectedSection}
                    >
                        {sections.map((id) => (
                            <Option key={id} value={id}>
                                {`Sección ${id}`}
                            </Option>
                        ))}
                    </Select>
                    {status && (
                        <div style={{ marginTop: 12 }}>
                            <Alert
                                showIcon
                                type={status.valid ? 'success' : 'error'}
                                message={
                                    status.valid
                                        ? `Puedes registrar ${status.remaining} promotor(es).`
                                        : status.message
                                }
                            />
                        </div>
                    )}
                </Modal>
            );
        };

        root.render(React.createElement(SectionModal));
    });
}
